import React, { Component, useEffect, useState } from 'react';
import axios from 'axios';

const ContractV2 = (props) => {

	const [id, setId] = useState(null);
	const [link, setLink] = useState(null);

	const handleEvent = (event) => {
		const type = event.data && event.data.type;
		const payload = event.data && event.data.payload;
	
		switch (type) {
			case 'session_view.document.loaded':
				console.log('Session view is loaded');
				break;
			case 'session_view.document.completed':
				console.log('Document is completed');
				console.log(payload);
				props.onChange('contract')(`https://app.pandadoc.com/a/#/document/v1/editor/${payload.uuid}/timeline`);

				break;
			case 'session_view.document.exception':
				console.log('Exception during document finalization');
				console.log(payload);
				break;
		}
	};

	useEffect(async () => {
		console.log('props ', props);
		const { corporation } = props.prevPageData;
		const {
			contact,
			address,
			account,
		} = props.allData;

		const {
			contractDownloadLink
		} = props.data;

		const combinedAddress = address.customAddress || [
			address.buildingName,
			address.shopNumber,
			address.floorLevel,
			address.street1,
			address.street2,
			address.suburb,
			address.state,
			address.postCode,
		].filter(v => !!v).join(', ');

		// const individualEmbedUuid = process.env.REACT_APP_PANDA_DOC_INDIVIDUAL_EMBED;
		// const corporateEmbedUuid = process.env.REACT_APP_PANDA_DOC_CORPORATION_EMBED;

		// const embedUuid = corporation ? corporateEmbedUuid : individualEmbedUuid;

		const docID = (contractDownloadLink.split('/')[8]);

		const doc = await axios.post(`/api/pandadoc/create-doc`, {
			corporation,
			docID,
			user: {
			  first_name: contact.givenNames,
        last_name: contact.surname,
        email: contact.email,
			},
			fields: {
				contact_name: { value: `${contact.givenNames} ${contact.surname}` },
				shop_name: { value: address.shopName },
				acn_abn: { value: account.abn },
				address: { value: combinedAddress },
				tel: { value: contact.mobile },
				email: { value: contact.email },
				business_name: { value: address.shopName },
				business_address: { value: combinedAddress },
				monday_open: { value: address.Monday.open ? address.Monday.from : '-' }, monday_close: { value: address.Monday.open ? address.Monday.to : '-' },
				tuesday_open: { value: address.Tuesday.open ? address.Tuesday.from : '-' }, tuesday_close: { value: address.Tuesday.open ? address.Tuesday.to : '-' },
				wednesday_open: { value: address.Wednesday.open ? address.Wednesday.from : '-' }, wednesday_close: { value: address.Wednesday.open ? address.Wednesday.to : '-' },
				thursday_open: { value: address.Thursday.open ? address.Thursday.from : '-' }, thursday_close: { value: address.Thursday.open ? address.Thursday.to : '-' },
				friday_open: { value: address.Friday.open ? address.Friday.from : '-' }, friday_close: { value: address.Friday.open ? address.Friday.to : '-' },
				saturday_open: { value: address.Saturday.open ? address.Saturday.from : '-' }, saturday_close: { value: address.Saturday.open ? address.Saturday.to : '-' },
				sunday_open: { value: address.Sunday.open ? address.Sunday.from : '-' }, sunday_close: { value: address.Sunday.open ? address.Sunday.to : '-' },
				final_business_name: { value: contact.shopName },
				final_financial_institution: { value: account.nameOfFinancialInstitution },
				final_bank_account_name: { value: account.namesOnAccount },
				final_bsb_number: { value: account.bsb },
				final_account_number: { value: account.accountNumber },
			},
		});

		if (!docID) {
			const docLink = `https://app.pandadoc.com/a/#/document/v1/editor/${doc.data.id}/timeline`;
			setLink(docLink);
			await props.updateDocLink(docLink);
		}

		const session = await axios.post(`/api/pandadoc/create-doc-link`, {
			id: doc.data.id,
			email: contact.email,
		});

		setId(session.data.id);
	}, []);

	useEffect(() => {
		window.addEventListener('message', (event) => {
			handleEvent(event);
		});

		return () => {
			window.removeEventListener('message', (event) => {
				handleEvent(event);
			});
		};
	}, []);

	return (
		<div style={{ marginTop: 50 }}>
			{!id && (
				<div
					style={{
						width: '100%',
						height: '100%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					Please wait...
				</div>
				)}
			{id && (
				<iframe
					src={`https://app.pandadoc.com/s/${id}`}
					width={900}
					height={700}
					frameborder="0"
					scrolling="no"
				/>
			)}
		</div>
	);
};

export default ContractV2;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/ContractV2/index.js